export default function scrollToElement(id: string) {
  setTimeout(() => {
    const el = document.getElementById(id)
    if (el && el.scrollIntoView) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }, 0)
}
